import { render } from "./away.vue?vue&type=template&id=37f2356a&ts=true"
import script from "./away.vue?vue&type=script&lang=ts"
export * from "./away.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/thelounge/thelounge/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__